import React, { useEffect, useState } from 'react';
import { API } from 'aws-amplify';
import { useQuery } from 'react-apollo';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import Form from 'components/form';
import Button from 'components/common/Button';
import TextField from 'components/form/Input';
import Select from 'components/form/Select';
import Dropzone from 'components/form/Dropzone';
import DateInput from 'components/form/DateInput';
import CheckBox from 'components/form/Checkbox';
import RichTextEditor from 'components/form/RichTextEditor';
import useSnack from 'hooks/useSnack';
import Toggle from '@material-ui/core/Switch';
import { FormControlLabel } from '@material-ui/core';
import { GET_CURRICULA } from 'graphql/admin/curriculum';
import { GET_TEMPLATES } from 'graphql/timeline-templates';
import times from 'lodash/times';
import PRODUCT_TYPE from 'constant/product-types';

const { FormItem } = Form;

const useStyles = makeStyles(() => ({
  drawer: {
    width: 900,
    padding: 20,
  },
  close: {
    position: 'absolute',
    right: 10,
    top: 10,
  },
}));

const PRICE_MODEL = [
  { label: 'One time', value: 'One time' },
  { label: 'Deferred success', value: 'Tier' },
  { label: 'Installment', value: 'Recurring' },
  { label: 'Installment - Perpetual', value: 'Perpetual' },
];

const currentyear = new Date().getFullYear();
const GRADUATION_YEARS = times(10).map((i) => ({
  label: currentyear + i,
  value: currentyear + i,
}));

const CREDIT_TYPE = [
  { label: 'Upgrade', value: 'upgrade' },
  { label: 'Meetings', value: 'meetings' },
  { label: 'Essays', value: 'essays' },
  { label: 'Extension', value: 'extension' },
  { label: 'Colleges', value: 'colleges' },
  // { label: 'Financial Review', value: 'financial_review' },
];

const stripSpace = (v, prev) => {
  if (v === prev) {
    return v;
  }
  return v.replace(' ', '');
};

const toNumber = (v, prev) => {
  if (v === prev) {
    return v;
  }
  return Number(v);
};

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const ProductForm = ({
  addonForm,
  showAddonForm,
  product,
  onSubmit,
  form,
  onClose,
  onSubmitAddon,
  plan_id,
  productData
}) => {
  const classes = useStyles();
  const snack = useSnack();
  const [file, setFile] = useState();
  const curriculumResponse = useQuery(GET_CURRICULA);
  const timelineResponse = useQuery(GET_TEMPLATES);
  const { getFieldDecorator, validateFields, getFieldValue } = form;
  const [checkProductExist, setCheckProductExist] = useState(null);
  const [previewButton, setPreviewbutton] = useState(true)



  const handleChange = (e) => {
    setCheckProductExist(e.target.value)
  }

  useEffect(() => {
    const result = productData?.some(item => (item.plan_id === checkProductExist || item.plan_id === plan_id));
    if (result) {
      setPreviewbutton(false)
    }
    else {
      setPreviewbutton(true)
    }
  }, [productData, checkProductExist])

  const handleAddonFormDisplay = (e) => {
    showAddonForm(e.target.checked);
  };

  const onAddonSave = () => {
    return validateFields().then(async (values) => {
      if (product) {
        values.id = product.id;
      }
      values.class_year = (values.class_year || []).map((key, index) => key);
      return onSubmitAddon(values).then(
        () => {
          snack.info('Addon saved.');
          onClose();
        },
        (e) => snack.error(e.message),
      );
    });
  };

  const onSave = () => {
    return validateFields()
      .then(async (values) => {
        if (file) {
          const name = file.name.trim();
          const base64 = await toBase64(file);
          const base64data = base64.split(',')[1];
          await API.post('api', '/admin/s3/upload', {
            body: {
              bucket: 'weadmit-static',
              name: `contracts/${name}`,
              contentType: 'application/pdf',
              data: base64data,
            },
          });

          values.contract_filename = name;
        } else {
          values.contract_filename = product?.contract_filename;
        }
        if (product) {
          values.id = product.id;
        }
        return onSubmit(values).then(
          () => {
            snack.info('Product saved.');
            onClose();
          },
          (e) => snack.error(e.message),
        );
      })
      .catch(() => snack.error('Please validate fields'));
  };

  const handleUpload = async (files) => {
    if (files && files.length) {
      setFile(files[0]);
    } else {
      setFile();
    }
  };

  const productType = getFieldValue('product_type');
  const pricingModel = getFieldValue('pricing_model') || product?.pricing_model;

  const config = getFieldValue('config');

  return (
    <Drawer
      ModalProps={{
        disableAutoFocus: true,
        disableEnforceFocus: true,
      }}
      open
      anchor="right"
      classes={{ paper: classes.drawer }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={3}
      >
        <Typography variant="h5">
          {product ? 'Edit Product' : 'Add Product'}
        </Typography>
        {!product && (
          <FormControlLabel
            control={
              <Toggle
                checked={addonForm}
                onChange={handleAddonFormDisplay}
                name="showAddonForm"
              />
            }
            label={
              <Typography color="primary" variant="body2">
                {' '}
                {'Add addon'}
              </Typography>
            }
          />
        )}
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>
        {addonForm ? (
          <Form>
            <FormItem>
              {getFieldDecorator('package_name', {
                initialValue: product?.package_name,
                rules: [{ required: true }],
              })(<TextField label="Package name" />)}
            </FormItem>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('product_type', {
                    initialValue: product?.product_type,
                    rules: [{ required: true }],
                  })(
                    <Select
                      isMulti={true}
                      options={PRODUCT_TYPE}
                      label="Product Type"
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('class_year', {
                    initialValue: product && product['class_year'],
                    rules: [{ required: false }],
                  })(
                    <Select
                      isClearable
                      isMulti
                      options={GRADUATION_YEARS}
                      label="Class year"
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('credit_type', {
                    initialValue: product?.credit_type,
                    rules: [{ required: true }],
                  })(
                    <Select
                      transformValue
                      isMulti={false}
                      options={CREDIT_TYPE}
                      label="Credit Type"
                    />,
                  )}
                </FormItem>
              </Grid>
            </Grid>
            <Box>
              <Grid container spacing={2}>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.cc', {
                      initialValue: product?.credits.cc,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="CC Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.hc', {
                      initialValue: product?.credits.hc,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="HC Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.fa', {
                      initialValue: product?.credits.fa,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="FA Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.fafsa', {
                      initialValue: product?.credits.fafsa,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="FAFSA Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.css_profile', {
                      initialValue: product?.credits.css_profile,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="CSS Profile Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.fafsa_css', {
                      initialValue: product?.credits.fafsa_css,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(
                      <TextField
                        label="FAFSA + CSS Profile Credits"
                        type="number"
                      />,
                    )}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.cc_essay', {
                      initialValue: product?.credits.cc_essay,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="CC Essay Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.hc_essay', {
                      initialValue: product?.credits.hc_essay,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="HC Essay Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.expert', {
                      initialValue: product?.credits?.expert || 0,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="Expert Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.colleges', {
                      initialValue: product?.credits?.colleges || 0,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="Colleges" type="number" />)}
                  </FormItem>
                </Grid>
              </Grid>
            </Box>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('extension_days', {
                    initialValue: product?.extension_days,
                    rules: [{ required: true }],
                  })(<TextField type="number" label="Extension Days" />)}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('price', {
                    initialValue: product?.price,
                    rules: [{ required: true }],
                  })(<TextField type="number" label="Price" />)}
                </FormItem>
              </Grid>
            </Grid>
            <Typography gutterBottom variant="body2">
              Addon Description
            </Typography>
            <FormItem>
              {getFieldDecorator('addon_info', {
                initialValue: product?.addon_info,
                rules: [{ required: true }],
              })(
                <RichTextEditor placeholder="Enter addon info shown in email" />,
              )}
            </FormItem>
            <Box marginTop={3}>
              <Button variant="contained" color="primary" onClick={onAddonSave}>
                Save
              </Button>
            </Box>
          </Form>
        ) : (
          <Form>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('package_name', {
                    initialValue: product?.package_name,
                    rules: [{ required: true }],
                  })(<TextField label="Package name" />)}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('plan_id', {
                    initialValue: product?.plan_id,
                    rules: [{ required: true }],
                    normalize: stripSpace,
                    onChange: (e) => handleChange(e),
                  })(<TextField label="Plan ID" />)}
                </FormItem>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('product_type', {
                    initialValue: product?.product_type,
                    rules: [{ required: true }],
                  })(
                    <Select
                      transformValue
                      isMulti={false}
                      options={PRODUCT_TYPE}
                      label="Product Type"
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('graduation_year', {
                    initialValue: product && product['graduation_year'],
                    rules: [{ required: false }],
                  })(
                    <Select
                      transformValue
                      isClearable
                      isMulti={false}
                      options={GRADUATION_YEARS}
                      label="Graduation year"
                    />,
                  )}
                </FormItem>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormItem>
                  {getFieldDecorator('program_start_date', {
                    initialValue: product?.program_start_date,
                  })(
                    <DateInput
                      disablePast
                      clearable
                      format="MM-DD-YYYY"
                      label="Program start date"
                      inputVariant="outlined"
                      fullWidth
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={4}>
                <FormItem>
                  {getFieldDecorator('program_end_date', {
                    initialValue: product?.program_end_date,
                    rules: [{ required: true }],
                  })(
                    <DateInput
                      disablePast
                      format="MM-DD-YYYY"
                      label="Program end date"
                      inputVariant="outlined"
                      fullWidth
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={4}>
                <FormItem>
                  {getFieldDecorator('mbg_period', {
                    initialValue: product?.mbg_period,
                    rules: [{ required: true }],
                  })(<TextField label="MBG Period (In days)" />)}
                </FormItem>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <FormItem>
                  {getFieldDecorator('pricing_model', {
                    initialValue: product?.pricing_model,
                    rules: [{ required: true }],
                  })(
                    <Select
                      transformValue
                      isMulti={false}
                      options={PRICE_MODEL}
                      label="Pricing model"
                    />,
                  )}
                </FormItem>
              </Grid>
              {pricingModel === 'Perpetual' && (
                <Grid item md={4}>
                  <FormItem>
                    {getFieldDecorator('trial_days', {
                      initialValue: product?.trial_days,
                      rules: [{ required: false }],
                    })(<TextField type="number" label="Trial period (days)" />)}
                  </FormItem>
                </Grid>
              )}
              {pricingModel === 'Recurring' && (
                <Grid item md={4}>
                  <FormItem>
                    {getFieldDecorator('installments', {
                      initialValue: product?.installments,
                      rules: [{ required: true }],
                    })(
                      <TextField
                        type="number"
                        label="Number of Installments"
                      />,
                    )}
                  </FormItem>
                </Grid>
              )}
              {pricingModel === 'Tier' && (
                <Grid item md={4}>
                  <FormItem>
                    {getFieldDecorator('tier_prices', {
                      initialValue: product?.tier_prices,
                      rules: [{ required: true }],
                    })(
                      <TextField label="Tier prices (Example: 1200/800/600)" />,
                    )}
                  </FormItem>
                </Grid>
              )}
            </Grid>
            <Grid container spacing={2}>
              <Grid item>
                <FormItem>
                  {getFieldDecorator('total', {
                    initialValue: product?.total,
                    rules: [{ required: true }],
                  })(
                    <TextField
                      type="number"
                      label="Total amount"
                      hint="For prepaid/deferred plan, it is the amount customer will be charged upfront. For Installment it is total amount."
                    />,
                  )}
                </FormItem>
              </Grid>

              <Grid item>
                <FormItem>
                  {getFieldDecorator('signup_fee', {
                    initialValue: product?.signup_fee,
                    rules: [{ required: true }],
                  })(
                    <TextField
                      label="Signup fee"
                      type="number"
                      hint="Enter 0 if no fee"
                    />,
                  )}
                </FormItem>
              </Grid>
            </Grid>
            <Box>
              <Grid container spacing={2}>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.cc', {
                      initialValue: product?.credits.cc,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="CC Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.hc', {
                      initialValue: product?.credits.hc,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="HC Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.fa', {
                      initialValue: product?.credits.fa,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="FA Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.cc_essay', {
                      initialValue: product?.credits.cc_essay,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="CC Essay Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.hc_essay', {
                      initialValue: product?.credits.hc_essay,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="HC Essay Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.expert', {
                      initialValue: product?.credits?.expert || 0,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="Expert Credits" type="number" />)}
                  </FormItem>
                </Grid>
                <Grid item md={2}>
                  <FormItem>
                    {getFieldDecorator('credits.colleges', {
                      initialValue: product?.credits?.colleges || 12,
                      rules: [{ required: true }],
                      normalize: toNumber,
                    })(<TextField label="Colleges" type="number" />)}
                  </FormItem>
                </Grid>
              </Grid>
            </Box>
            <Box marginBottom={3}>
              <Typography gutterBottom variant="body2">
                Service Details
              </Typography>
              <FormItem>
                {getFieldDecorator('service_details', {
                  initialValue: product?.service_details,
                  rules: [{ required: true }],
                })(
                  <RichTextEditor placeholder="Enter service details shown during checkout step" />,
                )}
              </FormItem>
            </Box>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('curriculum_id', {
                    initialValue: product?.curriculum_id,
                    rules: [{ required: true }],
                  })(
                    <Select
                      transformValue
                      isMulti={false}
                      label="Select Curriculum"
                      options={
                        curriculumResponse.data
                          ? curriculumResponse.data.curricula.map((i) => ({
                            label: i.name,
                            value: i.id,
                          }))
                          : []
                      }
                      isLoading={curriculumResponse.loading}
                    />,
                  )}
                </FormItem>
              </Grid>
              <Grid item md={6}>
                <FormItem>
                  {getFieldDecorator('timeline_id', {
                    initialValue: product?.timeline_id,
                    rules: [{ required: false }],
                  })(
                    <Select
                      isClearable
                      transformValue
                      isMulti={false}
                      label="Select Timeline Template"
                      options={
                        timelineResponse.data
                          ? timelineResponse.data.rows.map((i) => ({
                            label: i.name,
                            value: i.id,
                          }))
                          : []
                      }
                      isLoading={timelineResponse.loading}
                    />,
                  )}
                </FormItem>
              </Grid>
            </Grid>
            <FormItem>
              {getFieldDecorator('stripe_product_id', {
                initialValue: product?.stripe_product_id,
                rules: [{ required: true }],
              })(
                <TextField
                  label="Stripe Product ID"
                  hint="Make sure to use correct pricing in stripe"
                />,
              )}
            </FormItem>
            <Box>
              <FormItem>
                {getFieldDecorator('config.skipParentAccount', {
                  initialValue: product?.config?.skipParentAccount || false,
                  valuePropName: 'checked',
                })(<CheckBox label="Do not create parent account" />)}
              </FormItem>
              {config?.skipParentAccount && (
                <FormItem>
                  {getFieldDecorator('config.hideParentDetails', {
                    initialValue: product?.config?.skipParentDetails || false,
                    valuePropName: 'checked',
                  })(<CheckBox label="Hide parent details form" />)}
                </FormItem>
              )}
              <FormItem>
                {getFieldDecorator('config.skipStudentAccount', {
                  initialValue: product?.config?.skipStudentAccount || false,
                  valuePropName: 'checked',
                })(<CheckBox label="Do not create student account" />)}
              </FormItem>
              {config?.skipStudentAccount && (
                <FormItem>
                  {getFieldDecorator('config.hideStudentDetails', {
                    initialValue: product?.config?.hideStudentDetails || false,
                    valuePropName: 'checked',
                  })(<CheckBox label="Hide student details form" />)}
                </FormItem>
              )}
              <FormItem>
                {getFieldDecorator('config.skipPayment', {
                  initialValue: product?.config?.skipPayment || false,
                  valuePropName: 'checked',
                })(
                  <CheckBox label="Do not collect payment method during checkout" />,
                )}
              </FormItem>
              <Box mt={2}>
                <FormItem>
                  {getFieldDecorator('config.invoiceTemplateId', {
                    initialValue: product?.config?.invoiceTemplateId,
                    rules: [{ required: false }],
                    normalize: toNumber,
                  })(
                    <TextField
                      label="Sendgrid email template ID to send on successful payment"
                      placeholder="d-5f7993d0be2047168ce6804ed4c65631"
                      hint="Default template d-5f7993d0be2047168ce6804ed4c65631 is used unless specified."
                    />,
                  )}
                </FormItem>
              </Box>
            </Box>
            <Box>
              {product?.contract_filename && (
                <Typography variant="body2">
                  {product?.contract_filename}
                </Typography>
              )}
            </Box>
            <Dropzone
              onUpload={handleUpload}
              onRemove={() => setFile()}
              accept=".pdf"
              multiple={false}
            />
            <FormItem>
              {getFieldDecorator('active', {
                initialValue: product ? product.active : true,
                valuePropName: 'checked',
              })(<CheckBox label="Product is active" />)}
            </FormItem>
            <Box marginTop={3}>
              <Button variant="contained" color="primary" onClick={onSave}>
                Save
              </Button>
              <Button disabled={previewButton} style={{ marginLeft: '1em' }} variant="contained" color="primary" onClick={() => window.open(`/checkout?plan=${plan_id || checkProductExist}`)}>
                Preview
              </Button>
            </Box>
          </Form>
        )}
      </Box>
    </Drawer>
  );
};

export default Form.create()(ProductForm);
